import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PasswordAuthForm from './components/auth/PasswordAuthForm';

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if already authenticated
    const checkAuth = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BACKEND_URL;
        const response = await fetch(`${apiUrl}/api/auth/me`, {
          credentials: 'include'
        });
        
        if (response.ok) {
          // Already authenticated, redirect to dashboard
          navigate('/dashboard');
        }
      } catch (error) {
        // Not authenticated, show login page
        console.log('Not authenticated, showing login');
      }
    };

    checkAuth();
  }, [navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Use the browser's current origin so auth always returns to the exact domain the user is on
    // (works for production flippingfriends.co.uk, preview *.preview.emergentagent.com, and local dev).
    const redirectUrl = window.location.origin + '/dashboard';
    console.log('[Login] Initiating Google OAuth with redirect:', redirectUrl);
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4 py-8">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {/* Logo/Brand */}
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">
              Flipping Friends
            </h1>
            <p className="text-gray-600">
              The UK's first "Earn Your Subscription" platform for media resellers
            </p>
          </div>

          {/* Login Button */}
          <button
            onClick={handleGoogleLogin}
            data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700 text-white rounded-lg px-6 py-4 font-bold text-lg transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24">
              <path
                fill="#FFFFFF"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#FFFFFF"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FFFFFF"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#FFFFFF"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Continue with Google
          </button>

          <div className="flex items-center gap-3 my-6 text-xs text-gray-400 uppercase tracking-wide">
            <span className="flex-1 h-px bg-gray-200" /> or use email <span className="flex-1 h-px bg-gray-200" />
          </div>

          <PasswordAuthForm />

          {/* Info Text */}
          <p className="text-sm text-gray-500 text-center mt-6">
            By continuing, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>

        {/* Features */}
        <div className="mt-8 grid grid-cols-3 gap-4 text-center">
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-2xl font-bold text-blue-600">107%</div>
            <div className="text-xs text-gray-600 mt-1">Profit Increase</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-2xl font-bold text-green-600">875%</div>
            <div className="text-xs text-gray-600 mt-1">ROI on Sub</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-2xl font-bold text-purple-600">4</div>
            <div className="text-xs text-gray-600 mt-1">Buyers Checked</div>
          </div>
        </div>
      </div>
    </div>
  );
}
